export default __webpack_public_path__ + "static/media/Flunapen-50-ban.384d6a69.jpg";